export default "{\n    \"pageTitle\": \"Editar orden de trabajo\",\n    \"heading\": \"Editar orden de trabajo\",\n    \"submitButtonLabel\": \"Guardar\"\n}\n"